import { render, staticRenderFns } from "./CampaignKpiBox.vue?vue&type=template&id=378f2e3a&scoped=true&"
import script from "./CampaignKpiBox.vue?vue&type=script&lang=js&"
export * from "./CampaignKpiBox.vue?vue&type=script&lang=js&"
import style0 from "./CampaignKpiBox.vue?vue&type=style&index=0&id=378f2e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378f2e3a",
  null
  
)

export default component.exports